angular.module('bmsApp.directives').controller('LeavingPromptResponseModalCtrl', [
	'$scope',
	'$modalInstance',
	'visitType',
	'visit',
	'LeavingPromptResponseSvc',
	'$filter',
	function (
		$scope,
		$modalInstance,
		visitType,
		visit,
		LeavingPromptResponseSvc,
		$filter
		) {

		$scope.loading = true;
		$scope.visit = visit;
		$scope.title = 'Leaving Prompt Response';
		if(angular.isObject(visit) && angular.isDefined(visit.job_date)){
			$scope.title = 'Leaving Prompt Response - ' + $filter('amDateFormat')(visit.job_date, 'Do MMM YYYY');
			$scope.visitDate = $filter('amDateFormat')(visit.job_date, 'Do MMM YYYY')
		} else if (angular.isObject(visit) && angular.isDefined(visit.visit_date)){
			$scope.title = 'Leaving Prompt Response - ' + $filter('amDateFormat')(visit.visit_date, 'Do MMM YYYY');
			$scope.visitDate = $filter('amDateFormat')(visit.visit_date, 'Do MMM YYYY')
		}
		LeavingPromptResponseSvc.index({
			filter: {
				VisitableBelongsTo: {
					visitType: visitType,
					visitId: angular.isObject(visit) ? visit.id : visit,
				},
			},
		}).then(function(response){
			$scope.leaving_prompt_responses = response.data.leaving_prompt_response_collection;
			$scope.loading = false;
		});

		$scope.cancel = function () {
			$modalInstance.dismiss('cancel');
		};
		
	}]);
